import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { FuseSharedModule } from "@fuse/shared.module";
import { Ng4LoadingSpinnerModule } from "ng4-loading-spinner";
import { NgxLoadingModule } from "ngx-loading";
import { SharedModule } from "../shared/shared.module";
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, MatPaginatorModule, MatTableModule } from '@angular/material';
import { MensageriaRelatorioCobrancaComErroComponent } from './mensageria-relatoriocobrancacomerro.component';

const routes = [
    {
        path: 'mensageria-relatoriocobrancacomerro',
        component: MensageriaRelatorioCobrancaComErroComponent
    }
];


@NgModule({
  declarations: [MensageriaRelatorioCobrancaComErroComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    SharedModule,
    Ng4LoadingSpinnerModule,
    MatButtonModule,
    FuseSharedModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    MatTableModule,
    MatPaginatorModule,
  
    NgxLoadingModule.forRoot({ fullScreenBackdrop: true }),
  ],
  exports: [MensageriaRelatorioCobrancaComErroComponent]
})
export class MensageriaRelatorioCobrancaComErroModule { }
